import { Component, computed, effect, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../core/services/auth.service';
import { QuotaService } from '../../features/quotas/services/quota.service';
import { ChangePasswordModalComponent } from '../../shared/components/change-password-modal/change-password-modal.component';

@Component({
  selector: 'app-navbar',
  imports: [CommonModule, RouterLink, MatMenuModule, MatButtonModule, MatIconModule, MatDividerModule, MatSelectModule, TranslateModule, ChangePasswordModalComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  private quotaService = inject(QuotaService);
  private translate = inject(TranslateService);

  showLogoutModal = false;
  showChangePasswordModal = false;
  isMenuOpen = false;
  isAuthenticated = computed(() => this.authService.isAuthenticated());
  currentUser = computed(() => this.authService.currentUser());
  selectedSupplier = signal<any | null>(null);
  suppliers = signal<any[]>([]);
  currentLanguage = signal<string>('ru');

  languages = [
    { code: 'ru', name: 'Русский' },
    { code: 'ky', name: 'Кыргызча' }
  ];

  isOperator = computed(() => {
    return this.authService.hasRole('quota_operator') || this.authService.hasRole('quota_manager') || this.authService.hasRole('quota_viewer');
  });

  isSupplier = computed(() => {
    return this.authService.hasRole('quota_supplier');
  });

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
 
    const savedLang = localStorage.getItem('language') || 'ru';
    this.translate.setDefaultLang('ru');
    this.translate.use(savedLang);
    this.currentLanguage.set(savedLang);


    effect(() => {
      const roles = this.authService.userRoles();
 


      if (this.isOperator()) {
        this.loadSuppliers();
      }
    });
  }

  loadSuppliers(): void {

    const suppliersList = [
      { id: '123' },
      { id: '456' },
      { id: '789' }
    ];
    this.suppliers.set(suppliersList);
    

    if (suppliersList.length > 0 && !this.selectedSupplier()) {
      this.selectedSupplier.set(suppliersList[0]);
    }
  }

  selectSupplier(supplier: any): void {
    this.selectedSupplier.set(supplier);

  }

  getCurrentLanguageName(): string {
    const lang = this.languages.find(l => l.code === this.currentLanguage());
    return lang ? lang.name : 'Русский';
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
    this.currentLanguage.set(lang);
    localStorage.setItem('language', lang);
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  navigateToAdmin() {
    this.router.navigate(['/admin']);
  }

  logout() {
    this.showLogoutModal = true;
  }

  closeModal() {
    this.showLogoutModal = false;
  }

  confirmLogout() {
    this.authService.logout();
    this.showLogoutModal = false;
    this.closeMenu();
    this.router.navigate(['/']);
  }

  openChangePasswordModal() {
    this.showChangePasswordModal = true;
    this.closeMenu();
  }

  closeChangePasswordModal() {
    this.showChangePasswordModal = false;
  }

  getUserRole(): string {
    const user = this.currentUser();
    if (!user) {
      return 'Пользователь';
    }


    const roles = user.clientRoles?.['agro_tariff_quota'] || [];

    if (roles.length === 0) {
      return 'Пользователь';
    }


    const role = roles[0];
    const roleMap: Record<string, string> = {
      'quota_admin': 'Администратор',
      'quota_supplier': 'Поставщик',
      'quota_moderator': 'Модератор',
      'quota_operator': 'Оператор квот',
      'quota_manager': 'Менеджер квот',
      'quota_viewer': 'Наблюдатель'
    };
    return roleMap[role] || role;
  }
}
  

